import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail/delete-tag.svg';
const DeleteTagIcon = () => React.createElement(IconSvg, null);
export default DeleteTagIcon;
